module.exports = __webpack_public_path__ + "media/images/activeIconOther-7eb3f069.png";